import { Box, Button, Paper, Stack, Typography } from "@mui/material";
import { mainTextColor } from "../utility/colorPalette";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";

import ContactMailIcon from "@mui/icons-material/ContactMail";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { useNavigate } from "react-router-dom";

export const ContactPage = () => {
  const navigate = useNavigate();

  const handleFormOpen = () => {
    window.open(
      "https://docs.google.com/forms/d/e/1FAIpQLSeS1WKlK-w-m3oLc9VHxVemsd2ZZn1RL61vF6bjlYFXC8ZChA/viewform?usp=dialog",
      "_blank",
      "noopener,noreferrer"
    );
  };

  return (
    <>
      <Box sx={{ p: 1 }}>
        <Button onClick={() => navigate("/settings")}>
          <ArrowBackIosIcon fontSize="small" />
          戻る
        </Button>
      </Box>
      <Box
        sx={{
          maxWidth: 600,
          mx: "auto",
          p: 3,
          color: mainTextColor,
        }}
      >
        <Paper elevation={2} sx={{ p: 4, borderRadius: 2 }}>
          <Stack spacing={3} alignItems="center">
            <ContactMailIcon sx={{ fontSize: 48, color: "primary.main" }} />

            <Typography variant="h4" component="h1" textAlign="center">
              お問い合わせ
            </Typography>

            <Typography
              variant="body1"
              textAlign="center"
              sx={{ lineHeight: 1.8 }}
            >
              ご質問やご不明な点がございましたら、
              <br />
              お気軽に下記よりお問い合わせください。
            </Typography>

            <Button
              variant="contained"
              size="large"
              onClick={handleFormOpen}
              startIcon={<OpenInNewIcon />}
              sx={{
                mt: 2,
                px: 4,
                py: 1.5,
                borderRadius: 2,
                textTransform: "none",
                fontSize: "1.1rem",
              }}
            >
              問い合わせフォームを開く
            </Button>

            <Typography
              variant="caption"
              color="text.secondary"
              textAlign="center"
            >
              ※ 外部サイト（Google Forms）が新しいタブで開きます
            </Typography>
          </Stack>
        </Paper>
      </Box>
    </>
  );
};
